import React from 'react';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const isTorinoCenter = (item) => {
  const title = item?.shopping_center?.title?.toLowerCase() || '';
  const name = item?.shopping_center?.name?.toLowerCase() || '';
  return title.includes('torino') || name.includes('torino');
};

const mediaPreview = (file) => {
  const url = file?.url;
  if (!url) {
    return '—';
  }

  const videoExtensions = [
    '.mp4',
    '.avi',
    '.mov',
    '.wmv',
    '.flv',
    '.3gp',
    '.mpeg',
  ];
  const isVideo = videoExtensions.some(
    (ext) =>
      file.file_name?.toLowerCase().includes(ext) ||
      url.toLowerCase().includes(ext),
  );

  if (isVideo) {
    return (
      <video
        src={url}
        controls
        style={{ maxWidth: 320, maxHeight: 180, borderRadius: 6 }}
      />
    );
  }

  return (
    <a href={url} target='_blank' rel='noreferrer'>
      <img
        src={url}
        alt={file.file_name || 'media'}
        style={{
          maxWidth: 120,
          maxHeight: 120,
          objectFit: 'cover',
          borderRadius: 6,
        }}
      />
    </a>
  );
};

export const getHomepageSlideViewSections = (t, item) => {
  if (!item?.id) {
    return [];
  }

  const showFrench = isTorinoCenter(item);

  const contentFields = [
    {
      text: t('Outlet Village'),
      value: display(item.shopping_center?.title || item.shopping_center?.name),
    },
    { text: `${t('Titolo')} IT`, value: display(item.title) },
    { text: `${t('Titolo')} EN`, value: display(item.title_en) },
  ];

  if (showFrench) {
    contentFields.push({
      text: `${t('Titolo')} FR`,
      value: display(item.title_fr),
    });
  }

  contentFields.push(
    { text: `${t('Descrizione')} IT`, value: display(item.description) },
    { text: `${t('Descrizione')} EN`, value: display(item.description_en) },
  );

  if (showFrench) {
    contentFields.push({
      text: `${t('Descrizione')} FR`,
      value: display(item.description_fr),
    });
  }

  return [
    {
      title: t('Contenuto'),
      fields: contentFields,
    },
    {
      title: t('Info'),
      fields: [
        { text: t('Posizione'), value: display(item.position) },
        { text: t('Immagine/Video'), value: mediaPreview(item.file) },
      ],
    },
  ];
};
